import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import SolidHeartIcon from 'LuxKit/Icons/solid/SolidHeartIcon'
import type { ComponentProps } from 'react'
import { memo, useCallback } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import config from 'constants/config'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import usePendingLoginHandler from 'hooks/usePendingLoginHandler'
import useNavigateTo from 'hooks/useNavigateTo'
import { useWishlistIndex } from 'wishlists/hooks'
import NavBarButton from '../NavBarButton/NavBarButton'

const TripNavButton = styled(NavBarButton)`

    ${mediaQueryUp.tablet} {
      display: flex;
    }

`

type InheritedNavBarButtonProps = Pick<ComponentProps<typeof NavBarButton>, 'contentBreakpointMax'>

interface Props extends InheritedNavBarButtonProps {
  className?: string
}

function NavBarTripButton(props: Props) {
  if (!config.ENABLE_TRIP_PLANNER) return null

  return <WishlistNavButton {...props} />
}

function WishlistNavButton(props: Props) {
  const intl = useIntl()
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const navigateTo = useNavigateTo()
  const { data } = useWishlistIndex()
  const hasSavedItems = Boolean(
    data?.wishlists.find((wishlist) => wishlist.isDefault)?.itemCount,
  )

  const navigateToWishlists = useCallback(() => {
    navigateTo('/wishlists')
  }, [navigateTo])

  const handleWishlistClick = usePendingLoginHandler(navigateToWishlists, 'wishlistLogin')

  const wishlistText = intl.formatMessage({
    id: '8tn_OvJmXrdKVNnw4EQO',
    defaultMessage: 'Wishlist',
    description: 'Wishlist navigation button text in the website header',
  })

  return (
    <TripNavButton
      {...props}
      icon={hasSavedItems ? <SolidHeartIcon colour="favourite" /> : <LineHeartIcon />}
      contentBreakpointMin="desktop"
      {...(isLoggedIn ? { to: '/wishlists' } : { onClick: handleWishlistClick })}
    >
      {wishlistText}
    </TripNavButton>
  )
}

export default memo(NavBarTripButton)
